import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _mergeProps({
    type: _ctx.action,
    class: [_ctx.type, { 'text-white': _ctx.textWhite, new: _ctx.isNew }],
    style: { '--badge-text': `'${_ctx.$t('buttons.new')}'` }
  }, _ctx.$attrs), [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 16, _hoisted_1))
}